import { useEffect, useState } from 'react';
import { useUnit } from 'effector-react';
import { $userCardsStore } from '@lib/store/userManagement';
import { CardStatus } from '@shared/api/rest/cards';
import { RelatedCards } from '@widgets/card/relatedCards/relatedCards';
import { Pagination, Spinner } from '@shared/widgets';

interface IUserCardsProps {
  userId: string;
}

export const UserCards = (props: IUserCardsProps) => {
  const userCardsStore = useUnit($userCardsStore.store);

  const [status, setStatus] = useState<CardStatus>();
  const [index, setIndex] = useState<number>(1);
  const [count, setCount] = useState<number>(10);
  const [allTotal, setAllTotal] = useState<number>(0);

  useEffect(() => {
    $userCardsStore.events.getUserCards({
      Status: status,
      AssignedUserId: props.userId,
      FromIndex: (index - 1) * count,
      Count: count,
    });
  }, [props.userId, index, status, count]);

  useEffect(() => {
    if (status == undefined) setAllTotal(userCardsStore.data.total);
  }, [userCardsStore.data.total]);

  return (
    <>
      {userCardsStore.loading ? (
        <Spinner />
      ) : (
        <>
          <RelatedCards total={allTotal} cards={userCardsStore.data.data} activeTab={status} setActiveTab={setStatus} />
          {userCardsStore.data.data.length > 0 && (
            <Pagination
              className='mt-5'
              currentPage={index}
              totalItemCount={userCardsStore.data.total}
              countItemPage={count}
              onChangePage={setIndex}
              onChangeCountItemPage={setCount}
            />
          )}
        </>
      )}
    </>
  );
};
